module.exports = __webpack_public_path__ + "img/xinyuandan.463fce2b.png";